import Chart from '@stimulus-components/chartjs'
import Clipboard from '@stimulus-components/clipboard'
import AutoSubmit from '@stimulus-components/auto-submit'
import ScrollTo from '@stimulus-components/scroll-to'
import TextareaAutogrow from 'stimulus-textarea-autogrow'
import { registerControllers } from 'stimulus-vite-helpers'
import {
  Dropdown,
  Modal
} from 'tailwindcss-stimulus-components'

import { stimulus } from '~/init'

const controllers = import.meta.glob('~/controllers/**/*_controller.js', { eager: true })
import.meta.glob('../../components/**/*.{js,css}', { eager: true })

stimulus.register('auto-submit', AutoSubmit)
stimulus.register('chart', Chart)
stimulus.register('clipboard', Clipboard)
stimulus.register('dropdown', Dropdown)
stimulus.register('modal', Modal)
stimulus.register('scroll-to', ScrollTo)
stimulus.register('textarea-autogrow', TextareaAutogrow)
registerControllers(stimulus, controllers)
